import { customAlphabet } from "nanoid";
import slugify from "slugify";
import { TWITTER_X_SOCIAL_HANDLE } from "../config/project-details";

export function generateReferralCode() {
  // return nanoid(10); // Generates a 10-character unique code

  const nanoidBase58 = customAlphabet("ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz123456789", 10);
  const referralCode = nanoidBase58();

  return referralCode;
}

// To generate a slug for some text

export function generateSlug(text: string) {
  const slug = slugify(text, {
    lower: true,
    strict: true,
    remove: /[*+~.()'"!:@]/g,
  });

  return slug;
}

type SocialPlatform = "facebook" | "whatsapp" | "twitter" | "linkedin" | "email";

export function generateSocialShareUrl(
  platform: SocialPlatform,
  url: string,
  text: string = "",
  hashtags: string[] = [],
  subject: string = "",
) {
  const encodedUrl = encodeURIComponent(url);
  const encodedText = encodeURIComponent(text);
  const encodedSubject = encodeURIComponent(subject);
  const encodedHashtags = hashtags.map(encodeURIComponent).join(",");

  switch (platform) {
    case "facebook":
      return `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
    case "whatsapp":
      return `https://api.whatsapp.com/send?text=${encodedText}%20${encodedUrl}`;
    case "twitter":
      return `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedText}&via=${TWITTER_X_SOCIAL_HANDLE}&hashtags=${encodedHashtags}`;
    case "linkedin":
      return `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`;
    case "email":
      return `mailto:?subject=${encodedSubject}&body=${encodedText}%20${encodedUrl}`;
    default:
      throw new Error(`Unsupported platform: ${platform}`);
  }
}

// Recycled

// 23 May 2025

// export function generateTwitterShareUrl(url: string, text: string, hastags: string[] = []) {
//   return `https://twitter.com/intent/tweet?url=${url}&text=${text}&via=${TWITTER_X_SOCIAL_HANDLE}&hashtags=${hastags.join(",")}`;
// }
